import { UpdateArticleFolderDescription } from '../editArticleFolder/updateArticleFolderDescription';
import ArticleFolderImageActions from './articleFolderImageActions';
import { useHasPermission } from '../../../hooks/useHasPermission';
import { Box, Grid, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import Iconify from '../../Iconify';
import { useState } from 'react';
import RichTextDisplay from '../../richText/RichTextDisplay';
import { plainTextFromRichText } from '../../../utils/richText';
import '../../../css/sites/siteDetailsContent.css';

const ArticleFolderDetailsContent = () => {

  const hasArticleFolderUpdatePermission = useHasPermission('dossier_update');
  const articleFolderDetailsData = useSelector((state) => state.ArticleFolderDetailsData);

  const [modifyDescription, setModifyDescription] = useState(false);

  return (
    <Grid container spacing={3} className='siteDetailsContent_main_grid'>
      <Grid item xs={12} md={4} padding={3}>
        <Box className='siteDetailsContent_image_chiffre_box'>
          <ArticleFolderImageActions />
        </Box>
      </Grid>
      <Grid item xs={12} md={8} padding={3}>
        <Box className='modeEtConsigne_box'>
          <Box className='modeEtConsigne_edit_box'>
            <Typography className='modeEtConsigne_title'>Description</Typography>
            {hasArticleFolderUpdatePermission && <Iconify className='modeEtConsigne_edit_icon' icon={"ic:outline-edit"} onClick={() => setModifyDescription(true)} />}
          </Box>
          {plainTextFromRichText(articleFolderDetailsData?.description) ?
            <RichTextDisplay html={articleFolderDetailsData.description} /> :
            <Typography className='modeEtConsigne_dashed_typography'>Il n’existe aucun contenu dans cette section</Typography>
          }
        </Box>
      </Grid>
      {modifyDescription && <UpdateArticleFolderDescription modifyDescription={modifyDescription} setModifyDescription={setModifyDescription} />}
    </Grid>
  );
}

export default ArticleFolderDetailsContent;